import { render, staticRenderFns } from "./NewEmail.vue?vue&type=template&id=5323cc2e&scoped=true&"
import script from "./NewEmail.vue?vue&type=script&lang=js&"
export * from "./NewEmail.vue?vue&type=script&lang=js&"
import style0 from "./NewEmail.vue?vue&type=style&index=0&id=5323cc2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323cc2e",
  null
  
)

export default component.exports